import { useState } from "react"

import { AUTH0_CLIENTID } from "@app/services/env"

import { Stack, Typography, Popover, Avatar as MuiAvatar, Button, ButtonBase } from "@mui/material"
import { useAuth0 } from "@equipmentshare/auth0-react"
import { Logout } from "@mui/icons-material"

type UserProfileProps = {
	compact: boolean
}

export const UserProfile: React.FC<UserProfileProps> = ({ compact }) => {
	const { user, logout } = useAuth0()
	const name = user?.name?.trim() || ""

	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
	const open = Boolean(anchorEl)
	const id = open ? "profile-popover" : undefined

	const initials = () => {
		if (!name) {
			return "U"
		}
		const parts = name.split(" ").filter(Boolean)
		const initials = (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()

		return initials
	}

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => setAnchorEl(null)

	const handleLogout = () => {
		logout({ returnTo: window.location.origin, client_id: AUTH0_CLIENTID })
	}

	return (
		<>
			<ButtonBase
				onClick={handleClick}
				aria-describedby={id}
				aria-haspopup="menu"
				sx={{
					display: "inline-flex",
					alignItems: "center",
					gap: 2,
					borderRadius: 1,
					px: 0,
					py: 0,
				}}
			>
				<MuiAvatar
					sx={{
						cursor: "pointer",
						bgcolor: (theme) => theme.palette.grey[500],
						width: 40,
						height: 40,
						fontWeight: 600,
					}}
				>
					{initials()}
				</MuiAvatar>
				{!compact && (
					<Typography variant="body1" fontWeight={600}>
						{name || "User"}
					</Typography>
				)}
			</ButtonBase>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
				transformOrigin={{ vertical: "bottom", horizontal: "left" }}
				slotProps={{
					paper: { sx: { p: 2, minWidth: 200 } },
				}}
			>
				<Stack spacing={1}>
					<Typography variant="subtitle1" fontWeight={700}>
						{name || "User"}
					</Typography>

					<Button
						component="button"
						startIcon={<Logout />}
						onClick={handleLogout}
						sx={{ alignSelf: "flex-start", fontWeight: 600 }}
					>
						Logout
					</Button>
				</Stack>
			</Popover>
		</>
	)
}
export default UserProfile
